var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import i18n from "i18next";
import entries from "lodash/entries";
import { initReactI18next } from "react-i18next";
import common from "./assets/en.json";
import i18next from "i18next";
import assign from "lodash/assign";
export var replaceKeys = function (string, object, translator) {
    var _a;
    if (object === void 0) { object = {}; }
    try {
        (_a = string.match(translator.interpolator.nestingRegexp)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
            var cleanedKey = key.replace(new RegExp(translator.interpolator.nestingSuffix), "").replace(new RegExp(translator.interpolator.nestingPrefix), "");
            string = string.replace(key, translator.translate(cleanedKey, { skipInterpolation: true }));
        });
    }
    catch (e) {
        console.error(e);
    }
    return entries(object).reduce(function (transformedString, _a) {
        var key = _a[0], _b = _a[1], value = _b === void 0 ? "" : _b;
        var regex = new RegExp("\\{\\s*?" + key + "\\s*?\\}", "g");
        if (!transformedString.match(regex))
            return transformedString;
        if (typeof value === "function")
            value = value();
        return transformedString.replace(regex, value);
    }, string);
};
i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .use({
    type: "postProcessor",
    name: "lazyInterpolateWithFunctions",
    process: function (value, key, options, translator) {
        return options.skipInterpolation ? replaceKeys(value, options, translator) : value;
    }
})
    .init({
    resources: {
        en: { common: common }
    },
    debug: process.env.NODE_ENV === 'development',
    lng: "en",
    fallbackLng: "en",
    fallbackNS: 'common',
    defaultNS: 'app',
    postProcess: ["lazyInterpolateWithFunctions"],
    interpolation: {
        escapeValue: false,
        prefix: "{",
        suffix: "}",
    }
});
export var addTranslation = function (lang, data) {
    var ns = "app";
    if (!i18n.exists(lang)) {
        i18n.addResourceBundle(lang, ns, __assign({}, data));
        i18n.setDefaultNamespace(ns);
    }
};
export var defineProperties = function (object, extensions) {
    return new Proxy(assign(object, extensions), {
        get: function (target, prop) {
            return (prop in extensions) ? i18next.t(extensions[prop]) : target[prop];
        }
    });
};
